import { Button, Stack } from "@mui/material";
import React from "react";

interface IWrapperFilter {
  children: React.ReactNode;
  refreshFilter?: () => void;
}

function WrapperFilter({ children, refreshFilter }: IWrapperFilter) {
  return (
    <Stack sx={{ width: "100%", height: "100%" }}>
      <Stack
        sx={{
          width: "100%",
          height: "calc(100% - 45px)",
          overflow: "auto",
          px: 2,
          py: 1,
        }}
        gap={2}
      >
        {children}
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={1}
        sx={{
          height: "45px",
          borderTop: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={refreshFilter}
          variant="contained"
          size="small"
          color="secondary"
          sx={{
            textTransform: "none",
            color: "common.white",
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Làm mới
        </Button>
      </Stack>
    </Stack>
  );
}

export default WrapperFilter;
